<template>
  <div v-if="$resize && $mq.above(992)" class="footer">
    <div></div>
    <div class="text-right">
      <span v-for="(item, index) in lastUpdated" :key="index" class="mr-1">
        <span
          v-if="item.timestamp"
          class="badge"
          :class="item.timestamp === 'FAILED' ? 'badge-danger' : 'badge-primary'"
        >
          {{ item.type }}:
          <span class="dark sm">
            {{
            item.timestamp === 'FAILED' ? 'FAILED' : getMoment(item.timestamp)
            }}
          </span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { getMoment } from '@utils/helpers.js'

export default {
  components: {},
  props: {
    lastUpdated: {
      type: Array,
    },
  },
  methods: {
    getMoment: getMoment,
  },
}
</script>


<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
</style>
